/**
 * Constants for playbook preview feature
 */

/**
 * Number of play previews to fetch and display per playbook
 */
export const PREVIEW_PLAY_LIMIT = 4

/**
 * IntersectionObserver root margin for lazy loading
 * Thumbnails start loading 100px before becoming visible
 */
export const PREVIEW_LAZY_LOAD_MARGIN = '100px'
